import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {infoStatus, errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import Card from '../../core/components/Card'
import {RESET_LOGIN_DEMAND_UPDATED, sendResetLoginDemand, updateResetLoginDemand} from '../actions'
import {ResetLoginDemand} from '../models'
import i18n from '../i18n'

class ResetLoginDemandCard extends Component {
    static propTypes = {
    }

    componentWillMount() {
        const {dispatch, authenticated} = this.props

        dispatch(updateResetLoginDemand({
            oldLogin: authenticated.login,
            newLogin: authenticated.login
        }))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.authenticated != this.props.authenticated) {
            const {dispatch, authenticated} = nextProps

            dispatch(updateResetLoginDemand({
                oldLogin: authenticated.login,
                newLogin: authenticated.login
            }))
        }
    }

    _sendDemand() {
        const {dispatch, authenticated} = this.props

        return dispatch(sendResetLoginDemand()).then(() => {
            return dispatch(updateResetLoginDemand({
                oldLogin: authenticated.login,
                newLogin: authenticated.login
            }))
        }).then(() => {
            return dispatch(infoStatus(i18n.resetLoginEmailSent))
        })
    }

    render() {
        const {dispatch, form, demand, authenticated, ...others} = this.props

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const header = (
            <h5>{i18n.changeLogin}</h5>
        )

        return (
            <Card
                header={header}
                {...others}>
                <form className='form-horizontal'>
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='login'
                        label={requiredLabel(i18n.login)}
                        {...form.newLogin()} />
                </form>
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendDemand() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.resetLogin}
                    </LoaderButton>
                </ButtonToolbar>
            </Card>
        )
    }
}

ResetLoginDemandCard = connectForm({
    target: 'demand',
    schema: ResetLoginDemand.schema,
    action: RESET_LOGIN_DEMAND_UPDATED
})(ResetLoginDemandCard)

ResetLoginDemandCard = connect((state) => ({
    authenticated: state.user.authenticated,
    demand: state.user.resetLoginDemand
}))(ResetLoginDemandCard)

export default ResetLoginDemandCard


// WEBPACK FOOTER //
// ./lib/user/components/ResetLoginDemandCard.js